export default {
	title: "Importation de données",
	subtitle: "Importer des consultants à partir de feuilles de calcul XLSX",
	downloadTemplate: "Télécharger le modèle",
	uploadFile: "Envoyer le fichier",
	maxSize: "Taille maximale : {size} Mo",
	preview: "Aperçu",
	confirm: "Confirmer l'importation",
	validRows: "{count} ligne(s) valide(s)",
	invalidRows: "{count} ligne(s) avec erreurs",
	totalRows: "{count} ligne(s) au total",
	editableHint: "Vérifiez les noms ci-dessous. Vous pouvez modifier le prénom et le nom directement dans le tableau avant l'importation.",
	skippedRowsHint: "{count} ligne(s) avec erreurs ne seront pas importées. Corrigez et renvoyez la feuille de calcul ou importez ces enregistrements plus tard.",
	success: "{count} personne(s) importée(s) avec succès",
	partialSuccess: "{imported} sur {total} personne(s) importée(s)",
	goBack: "Retour",
	errors: {
		fileTooLarge: "Fichier trop volumineux. Maximum {size} Mo",
		importFailed: "Échec de l'importation des données",
	},
	result: {
		title: "Résultat de l'importation",
		viewConsultants: "Voir les consultants",
		importMore: "Importer davantage",
	},
	steps: {
		upload: "Envoi",
		preview: "Vérification",
		result: "Résultat",
	},
	template: {
		instructionsText: "Remplissez les données en suivant le modèle et envoyez le fichier pour vérification.",
	},
};
